import { RewardRarity } from '@/entities/cases'
import { Icon } from '../icon'
import { useStyles } from './styles'
import { $userLanguage } from '@/entities/user'
import { lang } from '@/shared/constants/lang'
import { useUnit } from 'effector-react'
import { addSuffix } from '@/shared/util/addSuffix'
import { convertMonts } from '@/shared/util/convertMonths'
import { formatNumber } from '@/shared/util/formatNumber'

type RewardValueProps = {
  initialValue: number | string
  kind: number
  text: string | undefined
  isClaimed: boolean | undefined
}

export interface rewardInfo {
  amountOfPoints?: number | string
  text?: string
  isSmall?: boolean
  isIcon?: boolean
  boxName?: string
  isClaimed?: boolean
  rarity: number
  kind: number
  imgStyles?: React.CSSProperties
  webp?: boolean
}
export type RewardType = { [key: number]: { rarity: string; chance: string } }

export const RewardPreview = (props: rewardInfo) => {
  const { boxName, amountOfPoints = 0, kind, isSmall, isClaimed, rarity, text, imgStyles, webp = false } = props
  const imageSrc = `/assets/lootBoxRelated/rewardsPreview/${props.boxName ?? 'gamed'}/${amountOfPoints}.${
    webp ? 'webp' : 'png'
  }`
  const userLang = useUnit($userLanguage)
  const texts = lang[userLang].pages.boxPage
  const { classes } = useStyles()
  const fontFamilyForClaimed = userLang === 'ru' ? 'Inter' : 'Space Grotesk'

  return (
    <div
      className={classes.root}
      data-small={isSmall}
      data-rewardtype={RewardRarity[rarity].toLowerCase()}
    >
      <div
        className={classes.claimedReward}
        data-isclaimed={isClaimed}
      >
        <Icon
          view="greyLock"
          style={{ alignSelf: 'center' }}
        />
        <span style={{ fontFamily: fontFamilyForClaimed }}>{texts.claimed}</span>
      </div>
      <img
        data-boxname={boxName}
        src={imageSrc}
        alt="rewardPreview"
        data-isclaimed={isClaimed}
        className={classes.img}
        style={imgStyles}
      />
      <div className={classes.contentWrapper}>
        <RendrerRewardValue
          text={text}
          initialValue={amountOfPoints}
          isClaimed={isClaimed}
          kind={kind}
        />
      </div>
    </div>
  )
}

function RendrerRewardValue(props: RewardValueProps) {
  const { text, initialValue, isClaimed, kind } = props
  const { classes } = useStyles()
  const userLang = useUnit($userLanguage)
  const texts = lang[userLang].pages.units

  const value = text ? (
    <span
      className={classes.rewardText}
      data-rewardtext={text}
      data-lang={userLang}
      data-isclaimed={isClaimed}
    >
      {text}
    </span>
  ) : kind === 3 ? (
    <>
      <div>
        <span className={classes.amountOfPoints}>{convertMonts(initialValue)}</span>
        <span className={classes.yearsAndMonths}>{Number(initialValue) >= 12 ? texts.year : texts.months}</span>
      </div>
    </>
  ) : (
    <span className={classes.amountOfPoints}>{formatNumber(addSuffix(initialValue))}</span>
  )

  if (kind === 0) return <>{value}</>

  if (kind === 2) {
    return (
      <>
        {value}
        <Icon
          view="tgStar"
          style={{
            width: 18,
            height: 18,
          }}
        />
      </>
    )
  }

  if (kind === 3) {
    return value
  }

  return (
    <>
      {value}
      <Icon
        view="gamed"
        style={{
          width: 18,
          height: 18,
          marginBottom: '1px',
        }}
      />
    </>
  )
}
